export default {

    notificationConfiguration: 'Notification Configuration',
    selectNotificationOption: 'Select the notifications you want to receive: ',
    emailNotifications: 'Email Notifications',
    smsNotifications: 'SMS Notifications',
    updatePersonalInformation: 'Update Personal Information',
    updatePersonalInformationError: 'An error occurred while updating your information',
    securityConfuguration: 'Security Configuration',
    MF2: 'Two-step authentication (2FA)',
    MF2Description: 'This option activates authentication with double factor using the Google Authenticator app.',
    MF2Error: 'Error changing the status of 2FA:',
};